<script lang="ts">
  import { cn } from '$lib/utils';
  import Icon from '$components/ui/icon/icon.svelte';
  import type { IconOptions } from '$components/ui/icon/icon.svelte';
  import type { CampaignColors } from '$lib/stores/campaigns';

  export let label: string;
  export let colors: CampaignColors | undefined = undefined;
  export let icon: IconOptions | undefined = undefined;
</script>

<div
  style:--altBackgroundColor={colors?.altBackgroundColor}
  style:--altTextColor={colors?.altTextColor}
  class={cn(
    'flex items-center gap-0.5 h-5 pr-1.5 pl-[5px] rounded-[6px] pointer-events-none',
    !colors
      ? 'bg-highlight/88 text-primary'
      : colors?.isBlackColor
        ? 'bg-accent text-highlight'
        : 'bg-[var(--altBackgroundColor)] text-[var(--altTextColor)]'
  )}
>
  {#if icon}
    <Icon size="xs" {icon} class="text-primary/88" />
  {/if}
  <span class="text-xs/none">{label}</span>
</div>
